import { homeSeoContent } from '@/mocks/seoContent';

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-background-50">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <a href="/" className="inline-flex items-center gap-2 mb-4">
              <span className="font-heading text-xl text-background-50 tracking-tight">
                VIGORBUY<span className="text-primary-300">.TEAM</span>
              </span>
            </a>
            <p className="text-background-50/70 text-sm leading-relaxed max-w-sm">
              {homeSeoContent.footerDescription}
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-semibold text-background-50 text-sm mb-4 uppercase tracking-wider">Navigate</h4>
            <ul className="space-y-2.5">
              <li><a href="/" className="text-background-50/70 text-sm hover:text-background-50 transition-colors duration-150">Home</a></li>
              <li><a href="/how-to-use-vigorbuy-spreadsheet" className="text-background-50/70 text-sm hover:text-background-50 transition-colors duration-150">Beginner Guide</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-background-50/70 text-sm hover:text-background-50 transition-colors duration-150">Official Store</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-semibold text-background-50 text-sm mb-4 uppercase tracking-wider">Categories</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-background-50/70 text-sm hover:text-background-50 transition-colors duration-150">Shoes</a></li>
              <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-background-50/70 text-sm hover:text-background-50 transition-colors duration-150">Hoodies</a></li>
              <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-background-50/70 text-sm hover:text-background-50 transition-colors duration-150">T-Shirts</a></li>
              <li><a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-background-50/70 text-sm hover:text-background-50 transition-colors duration-150">Bags</a></li>
            </ul>
          </div>

          <div className="md:col-span-4 flex flex-col items-start md:items-end">
            <p className="font-heading text-xl text-background-50 mb-1">{homeSeoContent.footerCopyright}</p>
            <p className="text-background-50/70 text-sm mb-4">{homeSeoContent.footerRights}</p>
            <p className="font-heading text-base text-background-50/50 italic text-right leading-relaxed max-w-xs">
              {homeSeoContent.footerTagline}
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/40 text-xs">
            Independent informational platform. Not affiliated with any spreadsheet service.
          </p>
          <div className="flex items-center gap-4">
            <a href="/" className="text-background-50/40 text-xs hover:text-background-50 transition-colors duration-150">Privacy</a>
            <a href="/" className="text-background-50/40 text-xs hover:text-background-50 transition-colors duration-150">Disclaimer</a>
            <a href="/" className="text-background-50/40 text-xs hover:text-background-50 transition-colors duration-150">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}